"use client";
import { useAuth } from './AuthContext';
import { SocketProvider } from './SocketProvider';

export default function Providers({ children }: { children: React.ReactNode }) {
  const { user } = useAuth() || {};
  return (
    <SocketProvider currentUser={user}>
      {children}
    </SocketProvider>
  );
}